import { getAxiosInstance, withSuppressedErrorToast } from '@/client/get-axios-instance';
import {
    MaxNotificationLinkCodeEntity,
    MaxNotificationSubscriptionEntity,
} from '@/entities/max-notification-subscription.entity';
import { EndpointOptions } from '@/types/endpoint.options';

type IssueMaxNotificationLinkCodePayload = {
    ttlMinutes?: number;
};

type UpdateMaxNotificationIntervalPayload = {
    subscriptionId: string;
    intervalMinutes: number;
};

const MAX_NOTIFICATIONS_API_PATH = '/api/marketplace/notifications/max';

class MaxNotificationsRepository {
    private readonly _axios = getAxiosInstance(MAX_NOTIFICATIONS_API_PATH);

    issueLinkCode(payload: IssueMaxNotificationLinkCodePayload, options?: EndpointOptions) {
        return this._axios.post<MaxNotificationLinkCodeEntity>('/link-codes', payload, {
            ...withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        });
    }

    getSubscriptions(options?: EndpointOptions) {
        return this._axios.get<MaxNotificationSubscriptionEntity[]>(
            '/subscriptions',
            withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        );
    }

    updateSubscriptionInterval(payload: UpdateMaxNotificationIntervalPayload, options?: EndpointOptions) {
        return this._axios.patch<MaxNotificationSubscriptionEntity>('/subscriptions', payload, {
            ...withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        });
    }
}

export const createMaxNotificationsRepository = () => new MaxNotificationsRepository();

export const maxNotificationsRepository = createMaxNotificationsRepository();
